/**
 * Injectable user registry: the staff directory (see directory.ts).
 *
 * `getUserById(id)` resolves a PERSON record id to its directory entry; a
 * `user`-typed field stores person ids. The lookup is host-supplied — a
 * consumer wires one with `registerUsers`; until then it reads `null`. Pure:
 * no client or store framework.
 */

export interface User {
  /** The person record id. */
  id: number
  name?: string | null
  slug?: string | null
  email?: string | null
  partner?: boolean
  active?: boolean
  /** The person record id again, for callers that read a user's record id. */
  record_id?: number | null
  /** A person who is not on the staff list (a former owner, assignee or
   *  actor), resolved for display only. Such a person cannot own a record. */
  former?: boolean
}

let resolver: (id: number) => User | null = () => null

/** Wire the host's user lookup. */
export function registerUsers(fn: (id: number) => User | null): void {
  resolver = fn
}

export const getUserById = (id: number): User | null => resolver(id)
